/**
 * API endpoints for Vimeo
 */
export class VimeoAPI {
    /**
     * Get a Vimeo video
     * @param videoId - The video ID
     * @returns Promise with the video
     */
    async getVideo(videoId) {
        return fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}&width=840&height=468`, {
            method: "GET",
        })
            .then((res) => (res.ok ? res : Promise.reject(res)))
            .then((response) => response.json())
            .catch((error) => {
            console.error("Error:", error);
        });
    }
}
